import { Doughnut } from 'react-chartjs-2'
import 'chart.js/auto'
import { ReportItem } from '../../libs/report-service'
import CharWrapper from '../ChartWrapper'
import styled from 'styled-components'
// import { Chart } from 'chart.js'
// import annotationPlugin from 'chartjs-plugin-annotation'

// Chart.register(annotationPlugin)

interface Props {
    reportItem: ReportItem
}

const CustomisedDoughnut = styled(Doughnut)`
    max-height: 300px;
`

export default function ReportBarChart({ reportItem }: Props) {
    const labels = Object.keys(reportItem.result)
    const rawValues = Object.values(reportItem.result)
    const total = rawValues.reduce((sum, v) => sum + v, 0)
    // const values = rawValues.map((v) =>
    //     total > 0 ? Math.round((v / total) * 100) : 0
    // )
    const values = rawValues.map((v) => Math.round(v * 10000) / 100)

    const data = {
        labels,
        datasets: [
            {
                label: reportItem.skill,
                data: values,
                backgroundColor: ['#31C690', '#ED6A5E', '#F4BD50'],
            },
        ],
    }

    return (
        <CharWrapper heading={reportItem.skill}>
            <CustomisedDoughnut options={options} data={data} />
        </CharWrapper>
    )
}

export const options = {
    plugins: {
        tooltip: {
            callbacks: {
                label: (context: any) => ` ${context.parsed}%`,
            },
        },
        // annotation: {
        //     annotations: {
        //         dLabel: {
        //             type: 'doughnutLabel',
        //             content: () => ['Total'],
        //             font: [{ size: 60 }, { size: 50 }, { size: 30 }],
        //             color: ['black', 'red', 'grey'],
        //         },
        //     },
        // },
    },
    legend: {
        position: 'bottom' as const,
    },
}
